/**
 * Gets option url.
 */
export const GET_OPTIONS_URL = (path: string, locale: string): string => '/opts/' + locale + path + '.json';